const config = {
  state: {
    fit: false,
    border: false,
    stripe: true,
    size: 'mini'
  },
  mutations: {
    setGridConfig: function (state, config) {
      if (config) {
        Object.keys(state).forEach(key => {
          let setVal = config[key]
          if (typeof setVal !== 'undefined') {
            state[key] = setVal
          }
        })
      }
    }
  }
}

export default config
